import React from 'react';
import styled, { keyframes } from 'styled-components';

const BarraProgreso = ({ porcentaje, className = '', color, cual, margin }) => {
  return (
    <div className={'barra-progreso ' + className}>
      <div className="barra-progreso_background-barra">
        <Bar
          className="barra-progreso_barra"
          porcentaje={porcentaje.replace(',', '.')}
          bar={cual}
          style={{
            backgroundColor: color ? color : '',
            marginLeft: margin ? margin + '%' : '',
          }}
        />
      </div>
    </div>
  );
};

const BarraProgresoStyled = styled(BarraProgreso)`
  position: relative;
  width: 100%;
  .barra-progreso_background-barra {
    background-color: #d8d8da;
    border-radius: 10px;
  }
`;
const Bar = styled(({ porcentaje, bar, ...rest }) => <div {...rest} />)`
  height: 6px;
  border-radius: 10px;

    width:${({porcentaje}) => porcentaje};
`;

export default BarraProgresoStyled;

{/* 

  @keyframes changewidth {
    from {
      width: 0%;
    }
  
    to {
      width: ${ ({porcentaje}) => porcentaje};
    }
  }

    animation-name: changewidth;
    animation-duration: 1s;
    animation-timing-function: linear;
*/}